























import { Component, Vue } from "vue-property-decorator";
import ProjectTemplateTask from "../models/project-template-task";
import { addDays, endOfDay } from "date-fns";

@Component({})
export default class PlanTaskEditModal extends Vue {
  task = {
    id: 0,
    name: "",
    start: new Date(),
    end: new Date(),
    duration: 1
  };

  public show(task: ProjectTemplateTask) {
    this.task = task;
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  okTitle = "保存";

  get cancelTitle() {
    if (this.task.id) {
      return "削除";
    } else {
      return "キャンセル";
    }
  }

  get cancelVariant() {
    if (this.task.id) {
      return "danger";
    } else {
      return "secondary";
    }
  }

  get duration() {
    return this.task.duration;
  }

  set duration(duration: number) {
    this.task.duration = duration;
    this.task.end = endOfDay(addDays(this.task.start, duration - 1));
  }

  submit() {
    this.$emit("submit", this.task);
  }

  cancel() {
    if (this.task.id) {
      this.$emit("delete", this.task);
    }
  }
}
